export enum Dish {
  ALL = 3,
  STARTER = 0,
  MAIN = 1,
  DESSERT = 2,
}
